import React, { type ComponentProps, memo } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Icon } from '@garnish/core';

import { ICON_CONTAINER_SIZE } from '../../CustomizationActiveIngredient.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientPlusIcon = memo((props: Props) => {
  return (
    <View style={styles.container}>
      <Icon name="IconPlus2" color={theme.colors.WHITE} width={24} height={24} {...props} />
    </View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: ICON_CONTAINER_SIZE,
    height: ICON_CONTAINER_SIZE,
    borderRadius: ICON_CONTAINER_SIZE,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.SPINACH,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof Icon>, 'name'>;
